import script from "./upload_avatar.vue?vue&type=script&setup=true&lang=js"
export * from "./upload_avatar.vue?vue&type=script&setup=true&lang=js"

import "./upload_avatar.vue?vue&type=style&index=0&id=941568fa&lang=scss&scoped=true"

import exportComponent from "/usr/local/jenkins/workspace/pc-web_pc-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-941568fa"]])

export default __exports__